import React, { Dispatch, SetStateAction } from 'react';
import styles from './TextButton.module.css';
import classNames from 'classnames';

type Props = {
  label: string | number;
  underscored: boolean;
  id: string;
  setUnderscored?: Dispatch<SetStateAction<null | string>>;
  className?: string;
};

const TextButton = ({ label, underscored, id, setUnderscored, className }: Props) => {
  return (
    <span
      className={classNames(
        styles.wrapper,
        { [styles.underscored]: underscored },
        className,
      )}
      id={id}
      onClick={() => {
        if (setUnderscored) setUnderscored(id);
      }}
    >
      {label}
    </span>
  );
};

export default TextButton;
